
// @ts-nocheck


export const localeCodes =  [
  "da",
  "de",
  "el",
  "en",
  "es",
  "fr",
  "hu",
  "it",
  "ja",
  "pl",
  "pt",
  "ru",
  "sv",
  "tr",
  "zh",
  "ae"
]

export const localeLoaders = {
  "da": [{ key: "../locales/da.json", load: () => import("../locales/da.json" /* webpackChunkName: "locale__vercel_path0_locales_da_json" */), cache: true }],
  "de": [{ key: "../locales/de.json", load: () => import("../locales/de.json" /* webpackChunkName: "locale__vercel_path0_locales_de_json" */), cache: true }],
  "el": [{ key: "../locales/fr.json", load: () => import("../locales/fr.json" /* webpackChunkName: "locale__vercel_path0_locales_fr_json" */), cache: true }],
  "en": [{ key: "../locales/en.json", load: () => import("../locales/en.json" /* webpackChunkName: "locale__vercel_path0_locales_en_json" */), cache: true }],
  "es": [{ key: "../locales/es.json", load: () => import("../locales/es.json" /* webpackChunkName: "locale__vercel_path0_locales_es_json" */), cache: true }],
  "fr": [{ key: "../locales/fr.json", load: () => import("../locales/fr.json" /* webpackChunkName: "locale__vercel_path0_locales_fr_json" */), cache: true }],
  "hu": [{ key: "../locales/hu.json", load: () => import("../locales/hu.json" /* webpackChunkName: "locale__vercel_path0_locales_hu_json" */), cache: true }],
  "it": [{ key: "../locales/it.json", load: () => import("../locales/it.json" /* webpackChunkName: "locale__vercel_path0_locales_it_json" */), cache: true }],
  "ja": [{ key: "../locales/ja.json", load: () => import("../locales/ja.json" /* webpackChunkName: "locale__vercel_path0_locales_ja_json" */), cache: true }],
  "pl": [{ key: "../locales/pl.json", load: () => import("../locales/pl.json" /* webpackChunkName: "locale__vercel_path0_locales_pl_json" */), cache: true }],
  "pt": [{ key: "../locales/pt.json", load: () => import("../locales/pt.json" /* webpackChunkName: "locale__vercel_path0_locales_pt_json" */), cache: true }],
  "ru": [{ key: "../locales/ru.json", load: () => import("../locales/ru.json" /* webpackChunkName: "locale__vercel_path0_locales_ru_json" */), cache: true }],
  "sv": [{ key: "../locales/sv.json", load: () => import("../locales/sv.json" /* webpackChunkName: "locale__vercel_path0_locales_sv_json" */), cache: true }],
  "tr": [{ key: "../locales/tr.json", load: () => import("../locales/tr.json" /* webpackChunkName: "locale__vercel_path0_locales_tr_json" */), cache: true }],
  "zh": [{ key: "../locales/zh.json", load: () => import("../locales/zh.json" /* webpackChunkName: "locale__vercel_path0_locales_zh_json" */), cache: true }],
  "ae": [{ key: "../locales/ae.json", load: () => import("../locales/ae.json" /* webpackChunkName: "locale__vercel_path0_locales_ae_json" */), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "i18n_config_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": ""
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "da",
      "files": [
        "locales/da.json"
      ]
    },
    {
      "code": "de",
      "files": [
        "locales/de.json"
      ]
    },
    {
      "code": "el",
      "files": [
        "locales/fr.json"
      ]
    },
    {
      "code": "en",
      "files": [
        "locales/en.json"
      ]
    },
    {
      "code": "es",
      "files": [
        "locales/es.json"
      ]
    },
    {
      "code": "fr",
      "files": [
        "locales/fr.json"
      ]
    },
    {
      "code": "hu",
      "files": [
        "locales/hu.json"
      ]
    },
    {
      "code": "it",
      "files": [
        "locales/it.json"
      ]
    },
    {
      "code": "ja",
      "files": [
        "locales/ja.json"
      ]
    },
    {
      "code": "pl",
      "files": [
        "locales/pl.json"
      ]
    },
    {
      "code": "pt",
      "files": [
        "locales/pt.json"
      ]
    },
    {
      "code": "ru",
      "files": [
        "locales/ru.json"
      ]
    },
    {
      "code": "sv",
      "files": [
        "locales/sv.json"
      ]
    },
    {
      "code": "tr",
      "files": [
        "locales/tr.json"
      ]
    },
    {
      "code": "zh",
      "files": [
        "locales/zh.json"
      ]
    },
    {
      "code": "ae",
      "files": [
        "locales/ae.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": true,
  "langDir": "locales/",
  "rootRedirect": null,
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const nuxtI18nOptionsDefault = {
  "experimental": {
    "localeDetector": ""
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [],
  "defaultLocale": "",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": null,
  "rootRedirect": null,
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false
}

export const normalizedLocales = [
  {
    "code": "da",
    "files": [
      {
        "path": "locales/da.json"
      }
    ]
  },
  {
    "code": "de",
    "files": [
      {
        "path": "locales/de.json"
      }
    ]
  },
  {
    "code": "el",
    "files": [
      {
        "path": "locales/fr.json"
      }
    ]
  },
  {
    "code": "en",
    "files": [
      {
        "path": "locales/en.json"
      }
    ]
  },
  {
    "code": "es",
    "files": [
      {
        "path": "locales/es.json"
      }
    ]
  },
  {
    "code": "fr",
    "files": [
      {
        "path": "locales/fr.json"
      }
    ]
  },
  {
    "code": "hu",
    "files": [
      {
        "path": "locales/hu.json"
      }
    ]
  },
  {
    "code": "it",
    "files": [
      {
        "path": "locales/it.json"
      }
    ]
  },
  {
    "code": "ja",
    "files": [
      {
        "path": "locales/ja.json"
      }
    ]
  },
  {
    "code": "pl",
    "files": [
      {
        "path": "locales/pl.json"
      }
    ]
  },
  {
    "code": "pt",
    "files": [
      {
        "path": "locales/pt.json"
      }
    ]
  },
  {
    "code": "ru",
    "files": [
      {
        "path": "locales/ru.json"
      }
    ]
  },
  {
    "code": "sv",
    "files": [
      {
        "path": "locales/sv.json"
      }
    ]
  },
  {
    "code": "tr",
    "files": [
      {
        "path": "locales/tr.json"
      }
    ]
  },
  {
    "code": "zh",
    "files": [
      {
        "path": "locales/zh.json"
      }
    ]
  },
  {
    "code": "ae",
    "files": [
      {
        "path": "locales/ae.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const STRATEGIES = {
  "PREFIX": "prefix",
  "PREFIX_EXCEPT_DEFAULT": "prefix_except_default",
  "PREFIX_AND_DEFAULT": "prefix_and_default",
  "NO_PREFIX": "no_prefix"
}
export const DEFAULT_LOCALE = ""
export const DEFAULT_STRATEGY = "prefix_except_default"
export const DEFAULT_TRAILING_SLASH = false
export const DEFAULT_ROUTES_NAME_SEPARATOR = "___"
export const DEFAULT_LOCALE_ROUTE_NAME_SUFFIX = "default"
export const DEFAULT_DETECTION_DIRECTION = "ltr"
export const DEFAULT_BASE_URL = ""
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"


